import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

const reviews = [
  {
    name: "Arshad Ilyas",
    text: "Good place for heavy machine, purchase and maintenance.",
    img: "https://lh3.googleusercontent.com/a/ACg8ocIUMdPhKaEd4knk-BDSu7x6VxifrrI05KUzvL0W2RLTSDxPqA=w90-h90-p-rp-mo-ba4-br100",
  },
  {
    name: "Syed Azhar Abbas",
    text: "Best services & experienced staff specially tahir sb he's such a great man..",
    img: "https://lh3.googleusercontent.com/a/ACg8ocLexkLLMsnGY2B2mtwhFkohHYPmENvDen_BpS4A8fP56gN29g=w72-h72-p-rp-mo-br100",
  },
  {
    name: "Waleed Abdullah",
    text: "Very cooperative staff the guy in the workshop is quite talented helped me in different situations. Appreciate the workshop staff outstanding.",
    img: "https://lh3.googleusercontent.com/a/ACg8ocL18iEAsRMjb5Icx8Qgo-5o9rkUaC_69GqKvIhEOQBnkyIMZPTF=w72-h72-p-rp-mo-ba3-br100",
  },
  {
    name: "Maarten Munnik",
    text: "We visited Isuzu gujranwala with our RV which had a leaking brake-cylinder. They fixed it in no-time and as a bonus adjusted all wheels. They charged very little and did a super job.Highly recommended!!!",
    img: "https://lh3.googleusercontent.com/a-/ALV-UjXtvJzdKGep9dJ35p0h2q1cO5cXdtUdT0lHXpvO99RCTcEODbYt=w72-h72-p-rp-mo-ba2-br100",
  },
  {
    name: "It.s Rajpot Shuban",
    text: "I am visit Isuzu Gujranwala motors excellent service CR great and fast service",
    img: "https://lh3.googleusercontent.com/a/ACg8ocJ2HC84hX-0msMT9i2Wpzc6KrudKa8TyO7HP0V5Hqo6YMCflw=w72-h72-p-rp-mo-br100",
  },
  {
    name: "Muhammad zishan aqeel",
    text: "Huge space for maintenance here at workshop Isuzu Gujranwala",
    img: "https://lh3.googleusercontent.com/a-/ALV-UjWNgH5kzVp4qNk7Iiwy6QuISukFjDQ0MO9eGuBBqUs__pTfJFbVAQ=w72-h72-p-rp-mo-ba4-br100",
  },
];

export default function IsuzuRaviReviews() {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((index + 1) % reviews.length);
  const prev = () => setIndex((index - 1 + reviews.length) % reviews.length);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [index]);

  return (
    <section className="relative bg-white text-gray-900 py-12 px-4 md:px-8 overflow-hidden border-t border-red-100">
      {/* Header */}
      <div className="text-center mb-8">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-3xl font-bold text-red-700"
        >
          What Our Customers Say
        </motion.h2>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="flex justify-center items-center gap-2 mt-2 text-gray-600 text-sm"
        >
          <img src="https://cdn.trustindex.io/assets/platform/Google/icon.svg" alt="Google" className="w-5 h-5" />
          <span>Trusted by verified customers via</span>
          <img src="https://cdn.trustindex.io/assets/platform/Trustindex/icon.svg" alt="Trustindex" className="w-5 h-5" />
        </motion.div>
      </div>

      {/* Review Card */}
      <div className="relative max-w-md mx-auto">
        <button
          onClick={prev}
          className="absolute -left-4 top-1/2 -translate-y-1/2 bg-red-600 text-white hover:bg-red-700 p-2 rounded-full shadow-md transition-all"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>

        <div className="overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.4 }}
              className="bg-red-50 border border-red-100 rounded-xl shadow-md p-6 text-center"
            >
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="h-4 w-4 text-yellow-400 fill-yellow-400" />
                ))}
              </div>
              <p className="text-sm text-gray-700 leading-relaxed mb-4">{reviews[index].text}</p>
              <div className="flex items-center justify-center gap-3">
                <img src={reviews[index].img} alt={reviews[index].name} className="w-10 h-10 rounded-full border-2 border-red-400" />
                <div className="text-left">
                  <h4 className="font-semibold text-gray-900 text-sm">{reviews[index].name}</h4>
                  <span className="text-xs text-gray-500">{reviews[index].date}</span>
                </div>
              </div>
              <div className="mt-3 flex justify-center items-center gap-1 text-xs text-gray-500">
                <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></span>
                Verified by TrustIndex
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <button
          onClick={next}
          className="absolute -right-4 top-1/2 -translate-y-1/2 bg-red-600 text-white hover:bg-red-700 p-2 rounded-full shadow-md transition-all"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>

      {/* Dots */}
      <div className="mt-6 flex justify-center gap-1.5">
        {reviews.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${i === index ? 'bg-red-600 scale-125' : 'bg-red-200'}`}
          />
        ))}
      </div>

      {/* CTA */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        className="text-center mt-6"
      >
        <a
          href="https://www.google.com/search?q=isuzu+gujranwala+motors&rlz=1C1JJTC_enPK1113PK1113&oq=isuzu+gujranwala+motors&gs_lcrp=EgZjaHJvbWUqEAgAEAAYkQIY4wIYgAQYigUyEAgAEAAYkQIY4wIYgAQYigUyEwgBEC4YrwEYxwEYkQIYgAQYigUyDQgCEAAYhgMYgAQYigUyDQgDEAAYhgMYgAQYigUyDQgEEAAYhgMYgAQYigUyBggFEEUYPTIGCAYQRRg9MgYIBxBFGD3SAQg1MDk0ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#lrd=0x391f2bb5f81bdad9:0x942b82d4c443f196,3,,,,"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-semibold py-2 px-5 rounded-full text-xs shadow-md hover:shadow-lg transition-all"
        >
          <img src="https://cdn.trustindex.io/assets/platform/Google/icon.svg" alt="Google" className="w-4 h-4" />
          Write a Review
        </a>
      </motion.div>
    </section>
  );
}
